// extracted by mini-css-extract-plugin
var _1 = "PageNav_active__e7YAK";
var _2 = "PageNav_arrow__VaMqH PageNav_pageButton__KYVeB";
var _3 = "PageNav_buttonsContainer__oWS6J";
var _4 = "PageNav_container__eA2j5";
var _5 = "PageNav_nextInactive__CxUwm";
var _6 = "PageNav_pageButton__KYVeB";
var _7 = "PageNav_pageNum__HWJ6d";
var _8 = "PageNav_prevInactive__YT+Zt";
export { _1 as "active", _2 as "arrow", _3 as "buttonsContainer", _4 as "container", _5 as "nextInactive", _6 as "pageButton", _7 as "pageNum", _8 as "prevInactive" }
